export default "__VITE_ASSET__76e0a9c3__"